import { UploadFile } from "@mui/icons-material";
import { Box, ButtonBase, Card, Stack, SxProps, Theme, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { Accept, useDropzone } from "react-dropzone";
import { Trans, useTranslation } from "react-i18next";

type Props = {
    onReceivedFiles: (files: File[]) => void;
    multiple?: boolean;
    disabled?: boolean;
    sx?: SxProps<Theme>;
    fileTypesToAccept?: Accept;
};

export default function FileDropZone({
    children,
    onReceivedFiles,
    disabled = false,
    multiple = false,
    sx,
    fileTypesToAccept,
}: PropsWithChildren<Props>) {
    const { t } = useTranslation("media");
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: fileTypesToAccept,
        multiple,
        onDrop: onReceivedFiles,
        disabled,
    });
    return (
        <Box width={1}>
            <Card
                {...getRootProps({
                    elevation: isDragActive ? 2 : 0,
                    sx: [
                        {
                            p: 8,
                            width: 1,
                            alignItems: "start",
                            backgroundColor: isDragActive ? "info.light" : "divider",
                            color: isDragActive ? "info.contrastText" : "text.primary",
                            "& .FileDropZone_header span": {
                                color: "primary.main",
                            },

                            transition: "background-color 250ms",
                            "&:hover": !disabled
                                ? {
                                      backgroundColor: "info.light",
                                      color: "info.contrastText",

                                      "& .FileDropZone_header": {
                                          textDecoration: "underline",
                                          "& span": { color: "info.contrastText" },
                                      },
                                  }
                                : {},
                        },
                        ...(Array.isArray(sx) ? sx : [sx]),
                    ],
                    component: ButtonBase,
                })}
            >
                <input {...getInputProps()} />

                <Stack direction="row" alignItems="center" flexWrap="wrap" justifyContent="center" gap={4}>
                    {!disabled && (
                        <Stack direction="row" className="FileDropZone_header" gap={1}>
                            <UploadFile />
                            <Typography variant="h6">
                                <Trans t={t} i18nKey="fileDropZone.text">
                                    Drag & drop or <span>browse</span>
                                </Trans>
                            </Typography>
                        </Stack>
                    )}
                    {children && (
                        <Box onClick={e => e.stopPropagation()} sx={{ flexBasis: "100%", textAlign: "left" }}>
                            {children}
                        </Box>
                    )}
                </Stack>
            </Card>
        </Box>
    );
}
